import React from 'react';

export default function BillingCancel() {
  return (
    <div style={{ padding: '2rem', maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
      <h2>Subscription cancelled.</h2>
      <p>You can subscribe anytime.</p>
    </div>
  );
}
